export default "__VITE_ASSET__CBS2CCqF__"